module.exports = __webpack_public_path__ + "img/inland_other.81b3fb01.jpg";